import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/Card";
import { Separator } from "../components/ui/Separator";
import CreateRouteCardForm from "../components/RouteSelect/CreateRouteCardForm";

import LiveOrEditRouteTab from "../components/RouteSelect/LiveOrEditRouteTab";
import ManageLocationsCard from "../components/RouteSelect/ManageLocationsCard";

type RouteSelectionType = "select" | "create" | "load" | "manage-locations";

function RouteSelection() {
  const [step, setStep] = useState<RouteSelectionType>("select");
  const navigate = useNavigate();

  const handleBackClick = () => {
    setStep("select");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      {step === "select" && (
        <>
          <div className="text-center mb-6">
            <h1 className="text-2xl font-semibold">
              Do you want to create a new route or load an existing one?
            </h1>
            <Separator className="my-4" />
          </div>
          <div className="grid gap-4 w-full max-w-md">
            <Card className="cursor-pointer" onClick={() => setStep("create")}>
              <CardHeader>
                <CardTitle>Create New Route</CardTitle>
              </CardHeader>
              <CardContent>Start fresh with a new route.</CardContent>
            </Card>

            <Card className="cursor-pointer" onClick={() => setStep("load")}>
              <CardHeader>
                <CardTitle>Load Existing Route</CardTitle>
              </CardHeader>
              <CardContent>
                Pick a live route to start editing or a route to continue
                editing.
              </CardContent>
            </Card>

            <Card
              className="cursor-pointer"
              onClick={() => setStep("manage-locations")}
            >
              <CardHeader>
                <CardTitle>Manage Countries & Cities</CardTitle>
              </CardHeader>
              <CardContent>Add or remove countries and cities.</CardContent>
            </Card>

            <Card
              className="cursor-pointer"
              onClick={() => navigate("/payments")}
            >
              <CardHeader>
                <CardTitle>Payments</CardTitle>
              </CardHeader>
              <CardContent>
                Manage discount tiers, promo codes, and partners. View purchase
                analytics.
              </CardContent>
            </Card>
          </div>
        </>
      )}

      {step === "create" && (
        <CreateRouteCardForm handleBackClick={handleBackClick} />
      )}

      {step === "load" && (
        <LiveOrEditRouteTab handleBackClick={handleBackClick} />
      )}

      {step === "manage-locations" && (
        <ManageLocationsCard handleBackClick={handleBackClick} />
      )}
    </div>
  );
}

export default RouteSelection;
